module.exports = __webpack_public_path__ + "static/3-f247eaf122092c65186bc9b4c140edc9.jpg";